var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-story-article-overlap-img"},[_c('asset',{staticClass:"c-story-article-overlap-img__img",attrs:{"asset":_vm.image}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }